import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import type { ConversationQuickReply } from '../../../services/conversationQuickReplies';
import { ModalShell } from '../../shared/ModalShell';

interface DeleteQuickReplyConfirmModalProps {
    reply: ConversationQuickReply;
    isDeleting: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export function DeleteQuickReplyConfirmModal({
    reply,
    isDeleting,
    onConfirm,
    onCancel
}: DeleteQuickReplyConfirmModalProps) {
    return (
        <ModalShell
            widthClassName="max-w-md"
            dismissible={!isDeleting}
            onDismiss={onCancel}
            labelledBy="delete-quick-reply-title"
        >
            <div className="flex items-start gap-4">
                <span className="flex-shrink-0 w-10 h-10 rounded-full bg-red-100 flex items-center justify-center">
                    <ExclamationTriangleIcon className="w-5 h-5 text-red-600" />
                </span>
                <div className="flex-1 min-w-0">
                    <h3
                        id="delete-quick-reply-title"
                        className="text-lg font-semibold text-gray-900"
                    >
                        Delete this quick reply?
                    </h3>
                    <p className="text-sm text-gray-500 mt-1 break-words">
                        <span className="font-medium text-gray-700">{reply.title}</span> will no
                        longer be offered in the chat composer.
                    </p>
                </div>
            </div>
            <div className="flex justify-end items-center gap-3 mt-6">
                <button
                    type="button"
                    autoFocus
                    onClick={onCancel}
                    disabled={isDeleting}
                    className="bg-white text-gray-800 border border-gray-300 px-4 py-2 rounded-lg hover:bg-gray-50 transition-colors font-semibold text-sm disabled:opacity-50"
                >
                    Cancel
                </button>
                <button
                    type="button"
                    onClick={onConfirm}
                    disabled={isDeleting}
                    className="px-4 py-2 text-sm font-semibold text-white bg-red-600 rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50"
                >
                    {isDeleting ? 'Deleting…' : 'Delete'}
                </button>
            </div>
        </ModalShell>
    );
}
